import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var AlertIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 16 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsx(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M8.006 12.5C7.405 12.5 7 12.959 7 13.506c0 .548.405.994 1.006.994A.97.97 0 0 0 9 13.506c0-.547-.405-1.006-.994-1.006ZM8 1.5a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0v-7a1 1 0 0 0-1-1Z"
        }) : /*#__PURE__*/ _jsxs("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ _jsx("path", {
                    d: "M11 8a1 1 0 0 1 2 0v6a1 1 0 1 1-2 0V8ZM11 18.006c0-.547.405-1.006 1.006-1.006.589 0 .994.459.994 1.006a.97.97 0 0 1-.994.994c-.601 0-1.006-.446-1.006-.994Z"
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    d: "M10.267 2.008c.77-1.335 2.697-1.335 3.466 0l9.79 16.994C24.29 20.335 23.328 22 21.79 22H2.21C.671 22-.29 20.335.477 19.002l9.79-16.994Zm2.166.749 9.79 16.993a.5.5 0 0 1-.433.75H2.21a.5.5 0 0 1-.433-.75l9.79-16.993a.5.5 0 0 1 .866 0Z",
                    clipRule: "evenodd"
                })
            ]
        })
    }));
};
